import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../../redux/slices/user";
import { message, Modal } from "antd";
import moment from "moment";
import {
  getAllBranches,
  selectBranches,
  takeOutBranch,
  DeliveryBranch,
  HotStopBranch,
  UberBranch,
  deleteLocation,
  toggleBranchService,
} from "../../redux/slices/branches";
import BranchesUI from "./components/BranchesUI";
import { getAllAreas, selectAreas } from "../../redux/slices/areas";

const Branches = () => {
  const [loading, handleLoading] = useState(true);
  const [branch, handleBranch] = useState(null);
  const [editorVisible, handleEditorVisible] = useState(false);
  const [scheduleVisible, setScheduleVisible] = useState(false);
  const [times, setTimes] = useState([moment(), moment()]);
  const branches = useSelector(selectBranches);
  const areas = useSelector(selectAreas);
  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  const initialFetch = useCallback(async () => {
    const response = await dispatch(getAllBranches(user.id));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
    const response2 = await dispatch(getAllAreas(user.id));
    if(response2.status !== "success") {
      message.error("No se cargaron las areas.");
    }
    handleLoading(false);
  }, [dispatch, user]);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  const openEditor = (branchToEdit) => {
    handleBranch(branchToEdit);
    handleEditorVisible(true);
  };

  const newBranch = () => {
    handleBranch(null);
    handleEditorVisible(true);
  };

  const closeEditor = () => {
    handleBranch(null);
    handleEditorVisible(false);
  };

  const handleTakeOut = async (idBranch, val) => {
    const response = await dispatch(takeOutBranch(idBranch, val, user.id));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const handleDelivery = async (idBranch, val) => {
    const response = await dispatch(DeliveryBranch(idBranch, val, user.id));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const handleHotStop = async (idBranch, val) => {
    const response = await dispatch(HotStopBranch(idBranch, val, user.id));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };


  const handleActiveUber = async (idBranch, razon, tiempo, val) => {
    const response = await dispatch(UberBranch(idBranch, val, razon, tiempo, user.id));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const handleServiceToggle = async (idBranch, service, val, reason = null, time = null) => {
    const response = await dispatch(toggleBranchService(idBranch, service, val, user.id, reason, time));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    }
  };

  const confirmDelete = (idBranch) => {
    Modal.confirm({
      title: "¿Estás segúro de eliminar esta sucursal?",
      content: "Esta información no se podrá recuperar.",
      okText: "Eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await removeBranch(idBranch);
      },
      onCancel() {},
    });
  };

  const removeBranch = async (idBranch) => {
    const response = await dispatch(deleteLocation(idBranch));
    if (response.status !== "success") {
      message.error("¡Hubo un problema!");
    } else {
      message.success("Sucursal eliminada correctamente");
    }
  };

  return (
    <BranchesUI
      loading={loading}
      branches={branches}
      areas={areas}
      branch={branch}
      openEditor={openEditor}
      editorVisible={editorVisible}
      closeEditor={closeEditor}
      initialFetch={initialFetch}
      newBranch={newBranch}
      handleTakeOut={handleTakeOut}
      handleDelivery={handleDelivery}
      handleHotStop={handleHotStop}
      handleActiveUber={handleActiveUber}
      handleServiceToggle={handleServiceToggle}
      handleBranch={handleBranch}
      scheduleVisible={scheduleVisible}
      setScheduleVisible={setScheduleVisible}
      times={times}
      setTimes={setTimes}
      confirmDelete={confirmDelete}
    />
  );
};

export default Branches;
